(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Gravatar", [], factory);
	else if(typeof exports === 'object')
		exports["Gravatar"] = factory();
	else
		root["Gravatar"] = factory();
})(self, () => {
return 